import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import MainMenu from './components/MainMenu';
import RequirementsForm from './components/RequirementsForm';
import ScheduleManagement from './components/ScheduleManagement';
import './App.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentPage, setCurrentPage] = useState('menu');
  
  // 자동 로그아웃 시간 (30분)
  const AUTO_LOGOUT_TIME = 30 * 60 * 1000;

  // 로그인 상태 및 마지막 페이지 확인 및 복원
  useEffect(() => {
    const savedLoginState = localStorage.getItem('loginState');
    const lastActivity = localStorage.getItem('lastActivity');
    const savedCurrentPage = localStorage.getItem('currentPage');
    
    if (savedLoginState === 'true' && lastActivity) {
      const timeDiff = Date.now() - parseInt(lastActivity);
      
      if (timeDiff < AUTO_LOGOUT_TIME) {
        setIsLoggedIn(true);
        // 마지막 접속 페이지 복원 (유효한 페이지인지 확인)
        const validPages = ['menu', 'requirements', 'schedule'];
        if (savedCurrentPage && validPages.includes(savedCurrentPage)) {
          setCurrentPage(savedCurrentPage);
        } else {
          setCurrentPage('menu');
        }
      } else {
        handleLogout();
      }
    }
  }, [AUTO_LOGOUT_TIME]);

  const handleLogin = (loginStatus) => {
    setIsLoggedIn(loginStatus);
    
    if (loginStatus) {
      // 기존에 저장된 페이지가 있는지 확인
      const savedCurrentPage = localStorage.getItem('currentPage');
      const validPages = ['menu', 'requirements', 'schedule'];
      
      if (savedCurrentPage && validPages.includes(savedCurrentPage)) {
        setCurrentPage(savedCurrentPage);
      } else {
        setCurrentPage('menu');
        localStorage.setItem('currentPage', 'menu');
      }
      
      localStorage.setItem('loginState', 'true');
      localStorage.setItem('lastActivity', Date.now().toString());
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setCurrentPage('menu');
    
    // 로그인 관련 데이터 삭제
    localStorage.removeItem('loginState');
    localStorage.removeItem('lastActivity');
    localStorage.removeItem('currentPage');
  };

  const handleNavigate = (page) => {
    setCurrentPage(page);
    // 페이지 변경 시 localStorage에 저장
    localStorage.setItem('currentPage', page);
    localStorage.setItem('lastActivity', Date.now().toString());
  };

  const handleBackToMenu = () => {
    setCurrentPage('menu');
    // 메뉴로 돌아갈 때도 localStorage에 저장
    localStorage.setItem('currentPage', 'menu');
    localStorage.setItem('lastActivity', Date.now().toString());
  };

  // 로그인하지 않은 경우 로그인 페이지 표시
  if (!isLoggedIn) {
    return (
      <div className="App">
        <Login onLogin={handleLogin} />
      </div>
    );
  }

  // 로그인한 경우 현재 페이지에 따라 컴포넌트 표시
  return (
    <div className="App">
      {currentPage === 'menu' && (
        <MainMenu 
          onNavigate={handleNavigate} 
          onLogout={handleLogout}
        />
      )}
      {currentPage === 'requirements' && (
        <RequirementsForm 
          onBack={handleBackToMenu} 
          onLogout={handleLogout}
        />
      )}
      {currentPage === 'schedule' && (
        <ScheduleManagement 
          onBack={handleBackToMenu} 
          onLogout={handleLogout}
        />
      )}
    </div>
  );
}

export default App;